import {Injectable, EventEmitter} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class DataService {

  private dealerPlan: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private dealerInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private dealerSubStatus: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private dealerCredits: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  private dealerABList: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public dealerPlan$: Observable<any> = this.dealerPlan.asObservable();
  public dealerInfo$: Observable<any> = this.dealerInfo.asObservable();
  public dealerSubStatus$: Observable<any> = this.dealerSubStatus.asObservable();
  public dealerCredits$: Observable<any> = this.dealerCredits.asObservable();
  public dealerABList$: Observable<any> = this.dealerABList.asObservable();
  constructor() {
  }

  StoreListUpdateRequestEvent = new EventEmitter();
  StoreListUpdatedEvent = new EventEmitter();
  localStorage = new EventEmitter<any>();

  storeAmount: number = 1;
  storeId = localStorage.getItem('store_id');
  storeURL = localStorage.getItem('store_url');
  storeName = localStorage.getItem('store_name');

  // StoreListUpdateRequestEvent
  emitStoreListUpdateRequestEvent() {
    this.StoreListUpdateRequestEvent.emit();
  }

  getStoreListUpdateRequestEvent() {
    return this.StoreListUpdateRequestEvent;
  }

  // StoreListUpdatedEvent
  emitStoreListUpdatedEvent(data) {
    this.storeAmount = data?.length ?? 1;
    this.StoreListUpdatedEvent.emit(data);
  }

  getStoreListUpdatedEvent() {
    return this.StoreListUpdatedEvent;
  }

  // localStorage Data
  emitLocalStorageData(data: any) {
    this.storeId = data['store_id'] ?? this.storeId;
    this.storeURL = data['store_url'] ?? this.storeURL;
    this.storeName = data['store_name'] ?? this.storeName;
    this.localStorage.emit(data);
  }

  getLocalStorageData() {
    return this.localStorage.asObservable();;
  }

  updateDealerPlan(data: any): void{
    this.dealerPlan.next(data);
  }

  getDealerPlan(): any {
    return this.dealerPlan.getValue();
  }

  updateDealerInfo(data: any): void{
    this.dealerInfo.next(data);
  }

  getDealerInfo(): any {
    return this.dealerInfo.getValue();
  }

  updateDealerSubStatus(data: any): void{
    this.dealerSubStatus.next(data);
  }

  getDealerSubStatus(): any {
    return this.dealerSubStatus.getValue();
  }

  updateDealerCredits(data: any): void{
    this.dealerCredits.next(data);
  }

  getDealerCredits(): any {
    return this.dealerCredits.getValue();
  }

  updateDealerABList(data: any): void{
    this.dealerABList.next(data);
  }

  getDealerABList(): any {
    return this.dealerABList.getValue();
  }

  private productFilters: any = null;
  private fromProductEdit: boolean = false;

  updateProductFilters(filters: any): void {
    this.productFilters = filters;
  }

  getProductFilters(): any {
    return this.productFilters;
  }

  clearProductFilters(): void {
    this.productFilters = null;
  }

  setFromProductEdit(val: boolean): void {
    this.fromProductEdit = val;
  }

  getFromProductEdit(): boolean {
    return this.fromProductEdit;
  }
}
